import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectStats = ({ projects }) => {
  const calculateStats = () => {
    const total = projects?.length;
    const active = projects?.filter(p => p?.status === 'active')?.length;
    const planning = projects?.filter(p => p?.status === 'planning')?.length;
    const completed = projects?.filter(p => p?.status === 'completed')?.length;
    const onHold = projects?.filter(p => p?.status === 'on-hold')?.length;
    
    const totalValue = projects?.reduce((sum, p) => sum + (p?.value || 0), 0);
    const activeValue = projects?.filter(p => p?.status === 'active')?.reduce((sum, p) => sum + (p?.value || 0), 0);
    
    const avgProgress = total > 0 
      ? projects?.reduce((sum, p) => sum + (p?.progress || 0), 0) / total 
      : 0;
    
    const totalServiceOrders = projects?.reduce((sum, p) => sum + (p?.serviceOrders || 0), 0);
    
    const overdueProjets = projects?.filter(p => {
      if (p?.status === 'completed' || p?.status === 'cancelled') return false;
      return new Date(p.endDate) < new Date();
    })?.length;

    return {
      total,
      active,
      planning,
      completed,
      onHold,
      totalValue,
      activeValue,
      avgProgress,
      totalServiceOrders,
      overdueProjets
    };
  };

  const stats = calculateStats();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })?.format(amount);
  };

  const statCards = [
    {
      title: 'Total de Projetos',
      value: stats?.total,
      icon: 'FolderOpen',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      description: `${stats?.active} ativos, ${stats?.planning} em planejamento`
    },
    {
      title: 'Valor Total',
      value: formatCurrency(stats?.totalValue),
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10',
      description: `${formatCurrency(stats?.activeValue)} em projetos ativos`
    },
    {
      title: 'Progresso Médio',
      value: `${Math.round(stats?.avgProgress)}%`,
      icon: 'TrendingUp',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      description: 'Progresso geral dos projetos'
    },
    {
      title: 'Ordens de Serviço',
      value: stats?.totalServiceOrders,
      icon: 'ClipboardList',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      description: 'Total de OS vinculadas'
    },
    {
      title: 'Projetos Concluídos',
      value: stats?.completed,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      description: `${((stats?.completed / (stats?.total || 1)) * 100)?.toFixed(1)}% do total`
    },
    {
      title: 'Projetos Atrasados',
      value: stats?.overdueProjets,
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      description: stats?.overdueProjets > 0 ? 'Requer atenção' : 'Nenhum atraso'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-professional transition-shadow"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            {stat?.title === 'Projetos Atrasados' && stats?.overdueProjets > 0 && (
              <div className="w-2 h-2 bg-error rounded-full animate-pulse"></div>
            )}
          </div>
          
          <div className="space-y-1">
            <h3 className="text-sm font-medium text-muted-foreground">
              {stat?.title}
            </h3>
            <p className="text-2xl font-bold text-foreground">
              {stat?.value}
            </p>
            <p className="text-xs text-muted-foreground">
              {stat?.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectStats;